import * as _ from 'lodash';
import React from 'react';
import Loadable from 'react-loadable';
import { Redirect, Switch, Route } from 'react-router-dom';
import ConferenceWrapper from '@components/Conference/ConferenceWrapper';

import EditableRoute from '@components/EditableRoute';
import PageWrapper from './components/PageWrapper';
import ElectronicDeliveryDetails from './pages/AppraisalNotices/ElectronicDeliveryDetails';

const Loading = () => <div />;

const AppraisalPageLibrary = Loadable({
  loader: () => import('@modules/appraisal/pages/webpageLibrary'),
  loading: Loading,
});

const AppraisalSubcomponentLibrary = Loadable({
  loader: () => import('@modules/appraisal/pages/subcomponentLibrary'),
  loading: Loading,
});

const AppraisalSubcomponentDetail = Loadable({
  loader: () => import('@modules/appraisal/pages/subcomponentDetail'),
  loading: Loading,
});

const AppraisalMenuProfile = Loadable({
  loader: () => import('@modules/appraisal/pages/menuprofileLibrary'),
  loading: Loading,
});

const AppraisalMenuProfileDetail = Loadable({
  loader: () => import('@modules/appraisal/pages/menuprofileDetail'),
  loading: Loading,
});

const ElectronicDeliveryRequestConfiguration = Loadable({
  loader: () => import('./pages/ElectronicDeliveryRequestConfiguration'),
  loading: Loading,
});

const AppraisalCodefileMaintenance = Loadable({
  loader: () => import('@modules/appraisal/pages/codefile'),
  loading: Loading,
});

const AppraisalWalkthroughSettings = Loadable({
  loader: () => import('@modules/appraisal/pages/walkthroughSettings'),
  loading: Loading,
});

const AppraisalWebpageDetail = Loadable({
  loader: () => import('@modules/appraisal/pages/webpageDetail'),
  loading: Loading,
});

const AbstractSubdivision = Loadable({
  loader: () => import('./pages/AbstractSubdivision'),
  loading: Loading,
});

const MarketArea = Loadable({
  loader: () => import('./pages/MarketArea'),
  loading: Loading,
});

const MarketAreaDetail = Loadable({
  loader: () => import('./pages/MarketAreaDetail'),
  loading: Loading,
});

const MarketAreaDetailEditor = Loadable({
  loader: () => import('./pages/MarketAreaDetailEditor'),
  loading: Loading,
});

const MarketAreaNewDetail = Loadable({
  loader: () => import('./pages/MarketAreaNewDetail'),
  loading: Loading,
});

const AbstractSubdivisionDetail = Loadable({
  loader: () => import('./pages/AbstractSubdivisionDetail'),
  loading: Loading,
});

const AbstractSubdivisionDetailEditor = Loadable({
  loader: () => import('./pages/AbstractSubdivisionDetailEditor'),
  loading: Loading,
});

const AbstractSubdivisionNewDetail = Loadable({
  loader: () => import('./pages/AbstractSubdivisionNewDetail'),
  loading: Loading,
});

const AbstractSubdivisionNewPlat = Loadable({
  loader: () => import('./pages/AbstractSubdivisionNewPlat'),
  loading: Loading,
});

const AbstractSubdivisionPlatEditor = Loadable({
  loader: () => import('./pages/AbstractSubdivisionPlatEditor'),
  loading: Loading,
});

const AppraisalModels = Loadable({
  loader: () => import('./pages/ModelsPage'),
  loading: Loading,
});

const AppraisalAddModels = Loadable({
  loader: () => import('./pages/CreateModel'),
  loading: Loading,
});

const AppraisalPricingSchedule = Loadable({
  loader: () => import('./pages/pricingSchedule'),
  loading: Loading,
});

const AppraisalIncomeModels = Loadable({
  loader: () => import('./pages/incomeModels'),
  loading: Loading,
});

const OwnershipAgentExport = Loadable({
  loader: () => import('./pages/Exports/OwnershipAgent'),
  loading: Loading,
});

const AppraisalDataExport = Loadable({
  loader: () => import('./pages/Exports/AppraisalData'),
  loading: Loading,
});

const AppraisalDataExportDetail = Loadable({
  loader: () => import('./pages/Exports/AppraisalData/Detail'),
  loading: Loading,
});

const AppraisalDataExportJSON = Loadable({
  loader: () => import('./pages/Exports/AppraisalDataJSON'),
  loading: Loading,
});

const AppraisalDataExportJSONDetail = Loadable({
  loader: () => import('./pages/Exports/AppraisalDataJSON/Detail'),
  loading: Loading,
});

const PTDListing = Loadable({
  loader: () => import('./pages/Exports/PTDListing'),
  loading: Loading,
});

const AppraisalFeatures = Loadable({
  loader: () => import('./pages/Features'),
  loading: Loading,
});

const AppraisalAdjustments = Loadable({
  loader: () => import('./pages/Adjustments'),
  loading: Loading,
});

const AppraisalEditModels = Loadable({
  loader: () => import('./pages/AppraisalEditModels'),
  loading: Loading,
});

const AppraiserSettings = Loadable({
  loader: () => import('./pages/AppraiserSettings'),
  loading: Loading,
});

const EditSchedule = Loadable({
  loader: () => import('./pages/pricingSchedule/editSchedule'),
  loading: Loading,
});

const MassRecalculation = Loadable({
  loader: () => import('./pages/massRecalculation'),
  loading: Loading,
});

const RollCorrectionGroups = Loadable({
  loader: () => import('./pages/rollCorrectionManager'),
  loading: Loading,
});

const RollCorrectionGroup = Loadable({
  loader: () => import('./pages/rollCorrectionManager/detail'),
  loading: Loading,
});

const RollCorrMoveOpenAppealHistory = Loadable({
  loader: () => import('./pages/rollCorrectionManager/moveOpenAppealHistory'),
  loading: Loading,
});

const RollCorrMoveOpenAppeals = Loadable({
  loader: () => import('./pages/rollCorrectionManager/moveOpenAppeals'),
  loading: Loading,
});

const MassRollCorrection = Loadable({
  loader: () => import('./pages/MassRollCorrect'),
  loading: Loading,
});

const Cache = Loadable({
  loader: () => import('./pages/Cache'),
  loading: Loading,
});

const AppraisalLandModels = Loadable({
  loader: () => import('./pages/LandModels'),
  loading: Loading,
});

const AppraisalLandModel = Loadable({
  loader: () => import('./pages/LandModels/LandModel'),
  loading: Loading,
});

const AppraisalLandModelDetail = Loadable({
  loader: () => import('./pages/LandModels/LandModelDetail'),
  loading: Loading,
});

const AppraisalDepreciationMethods = Loadable({
  loader: () => import('./pages/DepreciationMethods'),
  loading: Loading,
});

const AppraisalDepreciationCategories = Loadable({
  loader: () => import('./pages/DepreciationCategories'),
  loading: Loading,
});

const AppraisalNotices = Loadable({
  loader: () => import('./pages/AppraisalNotices'),
  loading: Loading,
});

const CaptureSubmissionValues = Loadable({
  loader: () => import('./pages/CaptureSubmissionValues'),
  loading: Loading,
});

const MassCreateComp = Loadable({
  loader: () => import('./pages/MassCreateComp'),
  loading: Loading,
});

const MassGeneration = Loadable({
  loader: () => import('./pages/MassGeneration'),
  loading: Loading,
});

const MassDeletion = Loadable({
  loader: () => import('./pages/MassDeletion'),
  loading: Loading,
});

const ImportPdfDocuments = Loadable({
  loader: () => import('./pages/ImportPdfDocuments'),
  loading: Loading,
});

const MassFileImports = Loadable({
  loader: () => import('./pages/MassFileImports'),
  loading: Loading,
});

const MassUpdatePropertyBeta = Loadable({
  loader: () => import('./pages/MassUpdatePropertyBeta'),
  loading: Loading,
});

const MicrosoftTeamsPOC2 = Loadable({
  loader: () => import('./pages/MicrosoftTeamsPOC2'),
  loading: Loading,
});

const EstimateCalcPrototype = Loadable({
  loader: () => import('./pages/EstimateCalcPrototype'),
  loading: Loading,
});

const OfficeInfo = Loadable({
  loader: () => import('./pages/OfficeInfo'),
  loading: Loading,
});

const DataEntry = Loadable({
  loader: () => import('./pages/DataEntry'),
  loading: Loading,
});

const BPPRenditionConfiguration = Loadable({
  loader: () => import('./pages/BPPRenditionConfiguration'),
  loading: Loading,
});

const TIRZ = Loadable({
  loader: () => import('./pages/TIRZ'),
  loading: Loading,
});

const AppealsCheckInPOC = Loadable({
  loader: () => import('./pages/ProofOfConcept/AppealsCheckInPOC'),
  loading: Loading,
});

const SB12CompressionCalculation = Loadable({
  loader: () => import('./pages/SB12CompressionCalculation'),
  loading: Loading,
});

const QueryExecutor = Loadable({
  loader: () => import('./pages/InternalAdministration/queryExecutor'),
  loading: Loading,
});

const LastTotalsRun = Loadable({
  loader: () => import('./pages/InternalAdministration/lastTotalsRun'),
  loading: Loading,
});

const SpreadsheetEntry = Loadable({
  loader: () => import('./pages/InternalAdministration/spreadsheetEntry'),
  loading: Loading,
});

const MeetingDetail = Loadable({
  loader: () => import('@modules/appraisalAdmin/pages/ProofOfConcept/meeting'),
  loading: Loading,
});

const LetterCaseSetting = Loadable({
  loader: () => import('./pages/LetterCaseSetting'),
  loading: Loading,
});

const PropertyDetailsView = Loadable({
  loader: () =>
    import('@modules/appraisal/pages/propertyDetails/PropertyDetailsView'),
  loading: Loading,
});

const PendingRequestsDisplay = Loadable({
  loader: () =>
    import(
      './pages/ElectronicDeliveryRequestsPortalNotifications/PendingRequestsDisplay'
    ),
  loading: Loading,
});

const PortalNotificationRecords = Loadable({
  loader: () =>
    import(
      './pages/ElectronicDeliveryRequestsPortalNotifications/PortalNotificationRecords'
    ),
  loading: Loading,
});

export const prefix = '/appraisal-admin';

/**
 * {
 *  menu - title of rleft side menu
 *  title - text of header on page
 * }
 */
export const appRoutes = {
  [`${prefix}/webpage`]: {
    menu: 'Webpages',
    component: AppraisalPageLibrary,
  },
  [`${prefix}/subcomponent`]: {
    menu: 'Subcomponent',
    component: AppraisalSubcomponentLibrary,
  },
  [`${prefix}/menuprofile`]: {
    menu: 'Menu',
    component: AppraisalMenuProfile,
  },
};

export const proofOfConceptRoutes = {
  [`${prefix}/poc-appeals-checkin`]: {
    title: 'Appeals Check In',
    component: AppealsCheckInPOC,
  },
  [`${prefix}/meeting`]: {
    title: 'Appeals Meeting',
    component: (props) => <MeetingDetail {...props} />,
  },
  [`${prefix}/compression-calculation`]: {
    title: 'SB 12 Compression Calculation',
    component: (props) => <SB12CompressionCalculation {...props} />,
  },
};

export const internalAdministrationRoutes = {
  [`${prefix}/query-executor`]: {
    title: 'Query Executor',
    component: (props) => <QueryExecutor {...props} />,
  },
  [`${prefix}/last-totals-run`]: {
    title: 'Last Totals Run',
    component: (props) => <LastTotalsRun {...props} />,
  },
  [`${prefix}/spreadsheet-entry`]: {
    title: 'Spreadsheet Entry',
    component: (props) => <SpreadsheetEntry {...props} />,
  },
};

export const codefileRoutes = {
  [prefix + 1]: {
    title: 'Matrix Axis',
    component: () => <div>Matrix Axis</div>,
  },
  [prefix + 2]: {
    title: 'Land Pricing Models',
    component: () => <div>Land Pricing Models</div>,
  },
  [prefix + 3]: {
    title: 'Improvement Pricing Models',
    component: () => <div>Improvement Pricing Models</div>,
  },
  [prefix + 4]: {
    title: 'App Pricing Models',
    component: () => <div>Matrix Axis</div>,
  },
  [prefix + 5]: {
    title: 'Depreciation Models',
    component: () => <div>Matrix Axis</div>,
  },
};

export const landPricingMaintenanceRoutes = {
  [`${prefix}/land-models`]: {
    menu: 'Land Pricing Table Models',
    component: (props) => <AppraisalLandModels {...props} />,
    viewPermissionSubject: 'AppraisalLandModel',
  },
  [`${prefix}/pricing-schedule/land`]: {
    menu: 'Pricing Schedule',
    component: (props) => <AppraisalPricingSchedule {...props} type="Land" />,
  },
  [`${prefix}/adjustments/land`]: {
    menu: 'Adjustments',
    component: (props) => (
      <AppraisalAdjustments {...props} title="Adjustments" />
    ),
  },
};

export const improvementPricingMaintenanceRoutes = {
  [`${prefix}/improvement-models`]: {
    menu: 'Improvement Models',
    component: (props) => (
      <AppraisalModels
        {...props}
        title="Improvement Models"
        modelType="Improvement"
      />
    ),
    viewPermissionSubject: 'AppraisalImprovementModel',
  },
  [`${prefix}/pricing-schedule/improvement`]: {
    menu: 'Pricing Schedule',
    component: (props) => (
      <AppraisalPricingSchedule {...props} type="Improvement" />
    ),
  },
  [`${prefix}/depreciation-schedule/improvement`]: {
    menu: 'Depreciation Schedule',
    component: (props) => (
      <AppraisalPricingSchedule {...props} type="Improvement-Depreciation" />
    ),
  },
  [`${prefix}/feature-schedule/improvement`]: {
    menu: 'Feature Schedule',
    component: (props) => (
      <AppraisalPricingSchedule {...props} type="Improvement Features" />
    ),
  },
  [`${prefix}/modifier-schedule/improvement`]: {
    menu: 'Modifier Schedule',
    component: (props) => (
      <AppraisalPricingSchedule {...props} type="Improvement Modifiers" />
    ),
  },
  [`${prefix}/features`]: {
    menu: 'Features',
    component: (props) => <AppraisalFeatures {...props} title="Features" />,
  },
  [`${prefix}/adjustments/improvement`]: {
    menu: 'Adjustments',
    component: (props) => (
      <AppraisalAdjustments {...props} title="Adjustments" />
    ),
  },
};

export const bppPricingMaintenanceRoutes = {
  [`${prefix}/bpp-models`]: {
    menu: 'BPP Models',
    component: (props) => (
      <AppraisalModels {...props} title="BPP Models" modelType="BPP" />
    ),
    viewPermissionSubject: 'AppraisalBppModel',
  },
  [`${prefix}/pricing-schedule/bpp`]: {
    menu: 'Pricing Schedule',
    component: (props) => <AppraisalPricingSchedule {...props} type="BPP" />,
  },
  [`${prefix}/depreciation-schedule/bpp`]: {
    menu: 'Depreciation Schedule',
    component: (props) => (
      <AppraisalPricingSchedule {...props} type="BPP-Depreciation" />
    ),
  },
  [`${prefix}/index-factor/bpp`]: {
    menu: 'Index Factor',
    component: (props) => (
      <AppraisalPricingSchedule {...props} type="BPP Index Factor" />
    ),
  },
  [`${prefix}/bpp-depreciation-methods`]: {
    menu: 'BPP Depreciation Methods',
    component: (props) => <AppraisalDepreciationMethods {...props} />,
  },
  [`${prefix}/bpp-depreciation-categories`]: {
    menu: 'BPP Depre Category Codes',
    component: (props) => <AppraisalDepreciationCategories {...props} />,
  },
};

export const estimateCalcRoutes = {
  [`${prefix}/estimatecalc/prototype`]: {
    menu: 'Prototype',
    component: (props) => <EstimateCalcPrototype {...props} />,
  },
};

export const pathToTitleAndComponent = {
  '/appraisal/notice/:noticeId/properties': {
    component: ({ match }) => (
      <Redirect
        to={`${prefix}/appraisal-notices/notice/${match.params.noticeId}/properties`}
      />
    ),
  },
  [prefix]: {
    component: Loadable({
      loader: () => import('./pages/Summary'),
      loading: Loading,
    }),
  },
  [`${prefix}/office-info`]: {
    title: 'Office Info',
    component: OfficeInfo,
  },
  [`${prefix}/webpage/edit/:webpageId`]: {
    title: 'Webpage',
    component: AppraisalWebpageDetail,
  },
  [`${prefix}/webpage/create`]: {
    title: 'Webpage',
    component: AppraisalWebpageDetail,
  },
  // subcomponent
  [`${prefix}/subcomponent/edit/:subcomponentId`]: {
    title: 'Subcomponent',
    component: AppraisalSubcomponentDetail,
  },
  [`${prefix}/subcomponent/create`]: {
    title: 'Subcomponent',
    component: AppraisalSubcomponentDetail,
  },
  //menu
  [`${prefix}/menuprofile/create`]: {
    title: 'Menu',
    component: AppraisalMenuProfileDetail,
  },
  [`${prefix}/menuprofile/edit/:menuprofileId`]: {
    title: 'Menu',
    component: AppraisalMenuProfileDetail,
  },
  // models
  [`${prefix}/land-models/:method`]: {
    title: 'Land Pricing Table Models',
    component: (props) => <AppraisalLandModel {...props} />,
  },
  [`${prefix}/improvement-models/create/:year`]: {
    title: 'Add Improvement Model',
    component: (rest) => (
      <AppraisalAddModels
        {...rest}
        modelType="Improvement"
        title="Improvement Models"
      />
    ),
  },
  [`${prefix}/bpp-models/create/:year`]: {
    title: 'Add BPP Model',
    component: (rest) => (
      <AppraisalAddModels {...rest} modelType="BPP" title="BPP Models" />
    ),
  },
  [`${prefix}/land-models/:method/add/:year/:isEditable`]: {
    title: 'Add Land Model',
    component: (props) => <AppraisalLandModelDetail {...props} />,
  },
  [`${prefix}/land-models/:method/edit/:id/:year/:isEditable`]: {
    title: 'Edit Land Model',
    component: (props) => <AppraisalLandModelDetail {...props} />,
  },
  [`${prefix}/improvement-models/edit/:modelID/:year`]: {
    title: 'Add Improvement Model',
    component: (rest) => (
      <AppraisalEditModels
        {...rest}
        modelType="Improvement"
        title="Improvement Models"
      />
    ),
  },
  [`${prefix}/bpp-models/edit/:modelID/:year`]: {
    title: 'Add BPP Model',
    component: (rest) => (
      <AppraisalEditModels {...rest} modelType="BPP" title="BPP Models" />
    ),
  },
  [`${prefix}/pricing-schedule/land/edit/:id`]: {
    component: EditSchedule,
  },
  [`${prefix}/pricing-schedule/improvement/edit/:id`]: {
    component: EditSchedule,
  },
  [`${prefix}/pricing-schedule/bpp/edit/:id`]: {
    component: EditSchedule,
  },
  [`${prefix}/feature-schedule/improvement/edit/:id`]: {
    component: EditSchedule,
  },
  [`${prefix}/modifier-schedule/improvement/edit/:id`]: {
    component: EditSchedule,
  },
  [`${prefix}/depreciation-schedule/land/edit/:id`]: {
    component: EditSchedule,
  },
  [`${prefix}/depreciation-schedule/improvement/edit/:id`]: {
    component: EditSchedule,
  },
  [`${prefix}/depreciation-schedule/bpp/edit/:id`]: {
    component: EditSchedule,
  },
  [`${prefix}/index-factor/bpp/edit/:id`]: {
    component: EditSchedule,
  },
  [`${prefix}/electronic-delivery-request-configuration`]: {
    component: ElectronicDeliveryRequestConfiguration,
  },
  [`${prefix}/codefile-maintenance`]: {
    component: AppraisalCodefileMaintenance,
  },
  [`${prefix}/walkthrough/settings`]: {
    component: AppraisalWalkthroughSettings,
  },
  [`${prefix}/mass-recalculation`]: {
    component: MassRecalculation,
  },
  [`${prefix}/roll-correction-groups`]: {
    component: RollCorrectionGroups,
  },
  [`${prefix}/roll-correction-groups/:rollCorrGroupID`]: {
    component: RollCorrectionGroup,
  },
  [`${prefix}/roll-correction-groups/:rollCorrGroupID/move-open-appeal-history`]:
    {
      component: RollCorrMoveOpenAppealHistory,
    },
  [`${prefix}/roll-correction-groups/:rollCorrGroupID/move-open-appeals`]: {
    component: RollCorrMoveOpenAppeals,
  },
  [`${prefix}/roll-correction-jobs`]: {
    component: MassRollCorrection,
  },
  [`${prefix}/appraiser-settings`]: {
    title: 'Appraiser Settings',
    component: AppraiserSettings,
  },
  [`${prefix}/abstract-subdivision`]: {
    title: 'Abstract Subdivision',
    component: AbstractSubdivision,
  },
  [`${prefix}/abstract-subdivision/:asCode`]: {
    component: AbstractSubdivisionDetail,
  },
  [`${prefix}/abstract-subdivision/:asCode/:year/edit-detail`]: {
    component: AbstractSubdivisionDetailEditor,
  },
  [`${prefix}/abstract-subdivision/:asCode/new-detail`]: {
    component: AbstractSubdivisionNewDetail,
  },
  [`${prefix}/abstract-subdivision/:asCode/new-plat`]: {
    component: AbstractSubdivisionNewPlat,
  },
  [`${prefix}/abstract-subdivision/:asCode/:platID/edit-plat`]: {
    component: AbstractSubdivisionPlatEditor,
  },
  [`${prefix}/market-area`]: {
    title: 'Market Area',
    component: MarketArea,
  },
  [`${prefix}/market-area/:mktCode`]: {
    component: MarketAreaDetail,
  },
  [`${prefix}/market-area/:mktCode/:year/edit-detail`]: {
    component: MarketAreaDetailEditor,
  },
  [`${prefix}/market-area/:mktCode/new-detail`]: {
    component: MarketAreaNewDetail,
  },
  [`${prefix}/cache`]: {
    component: Cache,
  },
  [`${prefix}/income-models`]: {
    title: 'Income Models',
    component: AppraisalIncomeModels,
  },
  [`${prefix}/letter-case-setting`]: {
    title: 'Letter Case Setting',
    component: LetterCaseSetting,
  },
  [`${prefix}/exports/ownership-agent`]: {
    title: 'Ownership Agent Export',
    component: OwnershipAgentExport,
  },
  [`${prefix}/exports/appraisal-data`]: {
    title: 'Appraisal Data Export',
    component: AppraisalDataExport,
  },
  [`${prefix}/exports/appraisal-data/:logID`]: {
    title: 'Appraisal Data Export Detail',
    component: AppraisalDataExportDetail,
  },
  [`${prefix}/exports/appraisal-json`]: {
    title: 'Appraisal Data Export JSON',
    component: AppraisalDataExportJSON,
  },
  [`${prefix}/exports/appraisal-json/:logID`]: {
    title: 'Appraisal Data Export JSON Detail',
    component: AppraisalDataExportJSONDetail,
  },
  [`${prefix}/exports/ptd-listing`]: {
    title: 'PTD Listing',
    component: PTDListing,
  },
  [`${prefix}/appraisal-notices`]: {
    component: AppraisalNotices,
  },
  [`${prefix}/capture-submission-values`]: {
    component: CaptureSubmissionValues,
  },
  [`${prefix}/mass-create-comp`]: {
    component: MassCreateComp,
  },
  [`${prefix}/mass-generation`]: {
    component: MassGeneration,
  },
  [`${prefix}/mass-deletion`]: {
    component: MassDeletion,
  },
  [`${prefix}/import-pdf-documents`]: {
    component: ImportPdfDocuments,
  },
  [`${prefix}/mass-file-imports`]: {
    component: MassFileImports,
  },
  [`${prefix}/mass-update-property-beta`]: {
    component: MassUpdatePropertyBeta,
  },
  [`${prefix}/data-entries`]: {
    title: 'Data Entry',
    component: DataEntry,
  },
  [`${prefix}/tirz`]: {
    title: 'Tax Increment Refinance Zone (TIRZ) Settings',
    component: TIRZ,
  },
  [`${prefix}/bpp-rendition-configuration`]: {
    title: 'Rendition Entry Configuration',
    component: BPPRenditionConfiguration,
  },
  [`${prefix}/microsoft-teams-poc2`]: {
    title: 'Microsoft Teams POC2',
    component: MicrosoftTeamsPOC2,
  },
  [`${prefix}/appraisal-notices/notice/:noticeId/properties`]: {
    title: 'Property Details',
    component: PropertyDetailsView,
  },
  ...proofOfConceptRoutes,
  ...internalAdministrationRoutes,
  ...appRoutes,
  ...landPricingMaintenanceRoutes,
  ...improvementPricingMaintenanceRoutes,
  ...bppPricingMaintenanceRoutes,
  ...estimateCalcRoutes,
  // ...codefileRoutes, // uncoment after implementing all pages
  [`${prefix}/portal-notification-records/pending`]: {
    component: PendingRequestsDisplay,
  },
  [`${prefix}/portal-notification-records/:runId`]: {
    component: PortalNotificationRecords,
  },
  [`${prefix}/appraisal-process-manager/appraisal-notices/:noticeId/electronic-delivery`]:
    {
      component: ElectronicDeliveryDetails,
    },
};

export const parseHeaderTitle = (path) => {
  const paths = Object.keys(pathToTitleAndComponent);
  const currentPath = paths.find((p) => p !== prefix && path.startsWith(p)); // skip '/' route

  return _.get(pathToTitleAndComponent[currentPath], 'title', '');
};

const AppraisalAdminRoutes = (props) => (
  <PageWrapper {...props}>
    <ConferenceWrapper prefix={prefix} {...props}>
      <Switch>
        <Route
          exact
          path="/appraisal/notice/:noticeId/properties"
          render={({ match }) => (
            <Redirect
              to={`${prefix}/appraisal-notices/notice/${match.params.noticeId}/properties`}
            />
          )}
        />
        {Object.entries(pathToTitleAndComponent).map(
          ([path, { component }]) => (
            <EditableRoute exact key={path} path={path} component={component} />
          ),
        )}
        <Redirect to={prefix} />
      </Switch>
    </ConferenceWrapper>
  </PageWrapper>
);

export default AppraisalAdminRoutes;
